<template>
  <div :class="{ 'report-course-page': true, active: active }">
    <PageSkeleton
      :animate="active"
      rotate
    >
      <ReportLeader
        :texts="['相信','过程']"
        :highlight-index="0"
        highlight-color="#2A77FF"
        :active="active"
      />
      <div class="report-text slide-in slide-in-1">
        2023年
      </div>
      <div class="report-text slide-in slide-in-2">
        你参与了<span class="text-highlight">{{ reportData.studyCourseCount }}</span>门课程的学习
      </div>
      <div class="report-text slide-in slide-in-3">
        共计<span class="text-highlight">{{ reportData.totalStudyHour }}+</span>小时
      </div>
      <div class="report-text slide-in slide-in-4">
        击败了<span class="text-highlight">{{ reportData.exceedRatio }}%</span>的同学
      </div>
      <div class="report-text" />
      <div v-if="reportData.totalStudyHour < 5">
        <div class="report-text slide-in slide-in-5">
          放弃不难
        </div>
        <div class="report-text slide-in slide-in-6">
          但坚持一定很酷
        </div>
      </div>
      <div v-else-if="reportData.totalStudyHour > 5 && reportData.totalStudyHour <= 10">
        <div class="report-text slide-in slide-in-5">
          行李很轻
        </div>
        <div class="report-text slide-in slide-in-6">
          梦想很重
        </div>
        <div class="report-text slide-in slide-in-7">
          感谢你从未停止求知和分享
        </div>
      </div>
      <div v-else-if="reportData.totalStudyHour > 10 && reportData.totalStudyHour <= 30">
        <div class="report-text slide-in slide-in-5">
          忙碌想把你埋了
        </div>
        <div class="report-text slide-in slide-in-6">
          但你是一颗种子
        </div>
        <div class="report-text slide-in slide-in-7">
          总能找到破土的方向
        </div>
      </div>
      <div v-else-if="reportData.totalStudyHour > 30 && reportData.totalStudyHour <= 80">
        <div class="report-text slide-in slide-in-5">
          让你变好的事情
        </div>
        <div class="report-text slide-in slide-in-6">
          过程都不会是轻松的
        </div>
        <div class="report-text slide-in slide-in-7">
          未来的你一定会感谢现在努力的自己
        </div>
      </div>
      <div v-else-if="reportData.totalStudyHour > 80">
        <div class="report-text slide-in slide-in-5">
          这并不是一串简单的数字
        </div>
        <div class="report-text slide-in slide-in-6">
          是你持续努力的结果
        </div>
        <div class="report-text" />
        <div class="report-text slide-in slide-in-7">
          是你热爱专注的厚度
        </div>
      </div>
    </PageSkeleton>
  </div>
</template>
<script setup>
import { inject } from "vue";
import PageSkeleton from "./PageSkeleton.vue";
import ReportLeader from "./ReportLeader.vue";
defineProps({
  active: {
    type: Boolean,
    default: false
  }
});
const reportData = inject("reportData")
</script>
<style lang="scss" scoped>
.report-course-page {
  background: url("~@/assets/student/studyReport/2023/bg-course.png");
  background-size: 100%;
  .text-highlight{
    color: #2A77FF;
  }
}
</style>